import React, { useState, memo } from "react";

import Toggle from "@cayuse/shared-react.components.form.toggle";
import { has } from "lodash";

import TextInput from "@cayuse/shared-react.components.form.inputs.text";
import { crunchClasses } from "@cayuse/shared-react.utils.helpers";

import Table from "components/Table";
import { useDictionary } from "hooks";
import { editRoleById, getId } from "store/actions/researchRoles";

import styles from "./styles.css";

export const EditRoleForm = memo(props => {
	const { role, actionsDisabled } = props;

	const [ isDirty, setIsDirty ] = useState(false);
	const dictionary = useDictionary("manageResearchTeamRoles");

	const isNewRole = has(role, "tempResearchRoleId");
	const id = getId(role);

	let shouldDisplayError = Boolean(role.error);
	if (isNewRole) {
		shouldDisplayError = isDirty && Boolean(role.error);
	}

	const inputClassNames = crunchClasses({
		[styles.editNameInput]: true,
		[styles.invalidEditNameInput]: shouldDisplayError,
	});

	return (
		<>
			<Table.Cell width='five'>
				<TextInput
					aria-label="Role name"
					data-testid={`role-input_${id}`}
					className={inputClassNames}
					value={role.name}
					onChange={e => {
						editRoleById(id, { name: e.target.value });
						setIsDirty(true);
					}}
					onFocus={() => {
						// show error immediately for existing roles
						!isNewRole && setIsDirty(true);
					}}
					onBlur={() => {
						// show error after blur for new roles
						isNewRole && setIsDirty(true);
					}}
				/>
				{shouldDisplayError && (
					<div role="alert" aria-live="polite" className={styles.error}>{role.error}</div>
				)}
			</Table.Cell>
			<Table.Cell>
				<em>
					{role.isPrincipalInvestigatorRole ? dictionary.principalInvestigatorRoleNote : null}
				</em>
			</Table.Cell>
			<Table.Cell>
				<Toggle
					label="Active research team role"
					checked={role.active}
					onChange={() => {
						editRoleById(id, { active: !role.active });
					}}
					disabled={role.isPrincipalInvestigatorRole || actionsDisabled}
				/>
			</Table.Cell>
		</>
	);
});
